import Slider from './Slider'
import Form from '../components/Form'
import '../css/inicio.css'

const Inicio = () => {
  return (
    <section className='sectionInicio'>
      <Slider style={{ position: 'relative', top: '0%' }}></Slider>
      <div className='introInicio'>
        <h2>Bienvenidos</h2>
        <p>
          Este sitio fue creado como un espacio para compartir mi universo artístico. Aquí vas a encontrar una selección de obras que abarcan distintas etapas, técnicas y búsquedas —desde el dibujo hasta el grabado—, así como información sobre exposiciones, premios y proyectos que han marcado mi recorrido.

          Me gusta pensar este espacio como una galería abierta, donde cada imagen y cada palabra invitan a detenerse, a mirar con atención y a descubrir resonancias personales. Porque el arte, para mí, es un modo de estar en el mundo: una forma de diálogo, de emoción y de pensamiento.

          A lo largo de más de 20 años de trabajo sostenido, he construido un camino que sigue en constante evolución. Este sitio es también una forma de registrar ese trayecto y de abrirlo al encuentro con quienes deseen recorrerlo conmigo.

          Gracias por estar acá. Te invito a explorar, observar y, si querés, a ponerte en contacto. Porque para mí, el arte es también una forma de diálogo constante con el mundo.

        </p>
      </div>

      <Form style={{ position: 'relative' }} />
    </section>

  )
}

export default Inicio